<template>
  <!-- The box of a dropdown menu, same as the profile menu's; rows sit 4px apart so hover never merges rows.
       Its border and soft brand shadow come from the global menu rule (base/_global.scss). -->
  <v-card rounded="lg" class="app-menu-card" :min-width="minWidth" :max-width="maxWidth">
    <div v-if="heading" class="text-body-small text-medium-emphasis px-5 pt-3 pb-1">{{ heading }}</div>
    <div :class="flush ? '' : 'd-flex flex-column ga-1 pa-2'">
      <slot />
    </div>
  </v-card>
</template>

<script setup>
defineProps({
  heading: { type: String, default: '' },
  minWidth: { type: [Number, String], default: 220 },
  maxWidth: { type: [Number, String], default: undefined },
  // The content brings its own padding (e.g. a two-column filter menu)
  flush: { type: Boolean, default: false }
})
</script>
